
import React, { useState, useEffect, useRef } from "react";
import PopupForm from "../../../Components/PopupForm";
import { useTranslation } from "react-i18next";
import { transactionAuditObject, objectMergeUpdate, viewObjectKeys } from "../../../Errors/Transactions/Transaction";
import moment from "moment/moment";
import helpers from "../../../assets/js/helper";
import Cookies from "universal-cookie";
import { Box, Button, Grid, Typography } from "@mui/material";
import CustomTextField from "../../../Components/CustomTextField";
import CustomeSelectField from "../../../Components/CustomeSelectField";
import geofenceAPI from "../../../Network/Geofence";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import auditStatusAPI from "../../../Network/AuditStatus";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CustomCheckBox from "../../../Components/CustomCheckBox";
import { useSelector } from "react-redux";

const cookies = new Cookies();



export default function AuditDetailFormContainer(props) {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [objectAuditDetails, setObjectAuditDetails] = useState([])
  const [loadingAuditStatuses, setLoadingAuditStatuses] = useState(true)
  const [auditStatuses, setAuditStatuses] = useState([])

  const getResources = async () => {

    try {

      const headerObject = {
        username: cookies.get("user_name") ? cookies.get("user_name") : null,
        user_id: cookies.get("user_id") ? cookies.get("user_id") : null,
        account_name: cookies.get("account_name") ? cookies.get("account_name") : null,
        account_id: cookies.get("account_id") ? cookies.get("account_id") : null,
        authHash: cookies.get("authHash") ? cookies.get("authHash") : null,
        sid: cookies.get("sid") ? cookies.get("sid") : null,
        baseurl: cookies.get("baseUrl") ? cookies.get("baseUrl") : null,
        id: cookies.get("id") ? cookies.get("id") : null,
      }
      const auditStatusesResult = await auditStatusAPI.getAuditStatusList({
        params: {
          ...headerObject,
          with_out_status_not_audited: true
        }

      })
      if (auditStatusesResult.status && auditStatusesResult?.data?.data && Array.isArray(auditStatusesResult?.data?.data)) {
        setAuditStatuses(auditStatusesResult?.data?.data)
      }
      setLoadingAuditStatuses(false);
    } catch (error) {
      console.log(error);
      setLoadingAuditStatuses(false);
    }

  }


  useEffect(() => {
    getResources()
    return () => {

    }
  }, [])

  useEffect(() => {

    console.log("1");

    if (Array.isArray(props?.object?.audit_statuses) && props?.object?.audit_statuses?.length) {
      console.log("2");
      setObjectAuditDetails(props?.object?.audit_statuses)
    }
    else {
      let transactionAuditStatus = []
      console.log("props?.transaction?.stop_violation_counter", props?.transaction?.stop_violation_counter);

      if (props?.transaction?.stop_violation_counter > 0 || props?.transaction?.stop_out_violation_counter > 0) {
        transactionAuditStatus?.push({
          id: null,
          audit_status_id: 1,
          note: "",
          transaction_audit_id: props?.object?.id
        })
      }
      if (props?.transaction?.has_violation > 0) {
        transactionAuditStatus?.push({
          id: null,
          audit_status_id: 2,
          note: "",
          transaction_audit_id: props?.object?.id
        })
      }
      if (props?.transaction?.is_arrived == 0) {
        transactionAuditStatus?.push({
          id: null,
          audit_status_id: 3,
          note: "",
          transaction_audit_id: props?.object?.id
        })
      }
      if (props?.transaction?.payload_not_unloaded > 0 || props?.transaction?.payload_unloaded_incomplete > 0) {
        transactionAuditStatus?.push({
          id: null,
          audit_status_id: 5,
          note: "",
          transaction_audit_id: props?.object?.id
        })
      }
      if (props?.transaction?.exceeded_allowed_time > 0) {
        transactionAuditStatus?.push({
          id: null,
          audit_status_id: 6,
          note: "",
          transaction_audit_id: props?.object?.id
        })
      }
      setObjectAuditDetails(transactionAuditStatus)
    }
  }, [props?.openForm, props?.object]);



  const submit = async (closeForm) => {

    if (closeForm) {
      props?.setObject({
        ...props?.object,
        audit_statuses: objectAuditDetails
      })
      props.setOpenForm(false);
    }

  };



  return (
    <PopupForm
      open={props?.openForm}
      setOpen={props?.setOpenForm}
      title={t("TRANSACTIONS.audit_details_view_title")}
      isFullScreen={false}

      content={<Box className="Container-fluid position-relative" sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} sx={{
          marginTop: '10px'
        }}>
          {loadingAuditStatuses ? <Typography sx={{
            fontFamily: 'Cairo',
            marginLeft: '20px'
          }}>{t('GLOBAL.loading')}</Typography> :
            auditStatuses?.map((item, index) => {

              let title = item?.name
              let checked = false
              let note = ""
              let auditStatus = null
              if (objectAuditDetails) {
                auditStatus = objectAuditDetails?.find(objectItem => objectItem?.audit_status_id == item?.id)
                if (auditStatus) {
                  note = auditStatus?.note
                  checked = true
                }

              }
              return (

                <React.Fragment key={index}>
                  <Grid xs={6} sm={6} md={6} lg={6} sx={{
                    padding: '0px'
                  }}>

                    <CustomCheckBox
                      label={<span style={{ fontFamily: 'Cairo' }}>{title}</span>}
                      notCheckedIcon={<CheckBoxOutlineBlankIcon />}
                      checkedIcon={<CheckBoxIcon />}
                      setChecked={(value) => {
                        if (!value) {
                          setObjectAuditDetails(
                            objectAuditDetails?.filter(item => item?.audit_status_id != auditStatus?.audit_status_id)
                          )
                        }
                        else {
                          setObjectAuditDetails(
                            [...objectAuditDetails, { id: null, audit_status_id: item?.id, note: "", transaction_audit_id: props?.object?.id }]
                          )
                        }

                      }}
                      checked={checked}
                    />

                  </Grid>
                  <Grid xs={6} sm={6} md={6} lg={6} sx={{
                    padding: '0px'
                  }}>
                    {checked ?
                      <CustomTextField
                        label={t("TRANSACTIONS.note")}
                        hasMultipleLine={true}

                        error={false}
                        message={[]}
                        onChange={(e) => {
                          setObjectAuditDetails(prevItems =>
                            prevItems.map(item =>
                              item?.audit_status_id === auditStatus?.audit_status_id ? { ...item, note: e.target.value, } : item
                            )
                          );

                        }}
                        value={note}
                        haswidth={true}
                        readOnly={false}
                        onClearClick={() => {

                          setObjectAuditDetails(prevItems =>
                            prevItems.map(item =>
                              item?.audit_status_id === auditStatus?.audit_status_id ? { ...item, note: "", } : item
                            )
                          );
                        }}
                      /> : null}
                  </Grid>
                </React.Fragment>)
            })}
        </Grid>

      </Box>

      }
      footer={
        <Box>
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#d1d0d0",
              borderColor: "#ffffff",
              color: "#000000",
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,

              "&:hover": {
                backgroundColor: maintheme?.secondary,
                borderColor: "#ffffff",
                color: "#fff",
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {

              props?.setOpenForm(false);
            }}
          >
            {t("GLOBAL.close")}
          </Button>
          <Button

            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "120px !important",
              minWidth: "120px !important",
              maxWidth: "120px !important",
              backgroundColor: maintheme?.secondary,
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              const closeForm = true
              submit(closeForm);
            }}
          >
            {t("GLOBAL.confirm")}
          </Button>

        </Box>

      }
    />
  );
}
